export const baseUrl =
  process.env.REACT_APP_PROD_ENV === "TRUE"
    ? process.env.REACT_APP_PROD_BASE_URL
    : process.env.REACT_APP_DEV_BASE_URL;

export const version = "v1/";
export const mode = "mp/";
export const role = "sellers/";
export const vrp = "vrp/";
export const spares = "spares/";
export const newPhones = "new_phones/";
export const login = "login/";
export const uploadFile = "upload_file/";
export const orders = "orders/";
export const  cancellation = "cancelled_orders/";
export const inventory = "inventory/"

export const ordersListUrl = `${baseUrl}${version}${mode}${role}${orders}`;
 

export const cancellationUrl = `${baseUrl}${version}${mode}${role}${orders}${cancellation}`